/**
 * Returns a Promise which resolves with delay
 *
 * @example
 *
 * delayFor(100).then(() => {});
 *
 * @param {Number} ms
 */
export function delayFor(ms = 100) {
  return new Promise((resolve, _reject) => {
    setTimeout(() => {
      // @ts-expect-error TS(2794): Expected 1 arguments, but got 0. Did you forget to... Remove this comment to see the full error message
      resolve();
    }, ms);
  });
}

/**
 *
 * @example
 *
 * useEffect(() => {
 *   const fn = () => console.log("Function");
 *   const removeTimer = createIntervalTimer(fn, 1000);
 *
 *   return removeTimer;
 * }, []);
 *
 * @param {Function} func
 * @param {Number} ms
 * @returns {Function} clear interval
 */
export function createIntervalTimer(func: any, ms = 500) {
  const timerId = setInterval(func, ms);

  return () => {
    clearInterval(timerId);
  };
}
